
document.addEventListener("DOMContentLoaded", () => {

  /**************************
   * Transparent Header JS *
  *************************/
  const transparentBanner = document.querySelector(
    '[data-transparent-header="true"]'
  );

  if (!transparentBanner) return;

  document.body.classList.add('transparent-header-enabled');

  const header = document.querySelector('sticky-header');
  if (header) {
    header.classList.add('transparent_header');
  }

});

document.addEventListener("DOMContentLoaded", function () {
  var tabs = document.querySelectorAll(".product__overview ul.tabs li");

  tabs.forEach(function (tab) {
    tab.addEventListener("click", function () {
      var tab_id = tab.getAttribute("data-tab");

      tabs.forEach(function (t) {
        t.classList.remove("current");
      });

      var tabContents = document.querySelectorAll(".product__overview .tab-content");
      tabContents.forEach(function (content) {
        content.classList.remove("current");
      });

      tab.classList.add("current");
      document.getElementById(tab_id).classList.add("current");
    });
  });
});

/**
 * <product-card-slider>
 * Standalone image carousel for product cards.
 * Does NOT conflict with Shopify's native <slider-component>.
 * Uses data-pcs-* attributes for scoping — never queries outside itself.
 */

if (!customElements.get('product-card-slider')) {
  class ProductCardSlider extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.touchStartX = 0;
      this.touchEndX = 0;
      this.swipeThreshold = 50;
      this.isTransitioning = false;
      this.mobileBreakpoint = 990;
      this.scrollTimeout = null;
    }

    connectedCallback() {
      this.track = this.querySelector('[data-pcs-track]');
      this.slides = this.querySelectorAll('[data-pcs-slide]');
      this.prevBtn = this.querySelector('[data-pcs-prev]');
      this.nextBtn = this.querySelector('[data-pcs-next]');
      this.counterCurrent = this.querySelector('[data-pcs-counter-current]');
      this.counterTotal = this.querySelector('[data-pcs-counter-total]');
      this.progressBar = this.querySelector('[data-pcs-progress-bar]');
      this.progressFill = this.querySelector('[data-pcs-progress-fill]');

      if (!this.track || this.slides.length === 0) return;

      this.totalSlides = this.slides.length;

      // Set total count
      if (this.counterTotal) {
        this.counterTotal.textContent = this.totalSlides;
      }

      // Hide arrows if only 1 slide
      if (this.totalSlides <= 1) {
        const buttonsWrapper = this.querySelector('[data-pcs-buttons]');
        if (buttonsWrapper) buttonsWrapper.style.display = 'none';
        return;
      }

      this.bindEvents();
      this.observeNearViewport();
      this.goToSlide(0, false);
      this.updateProgressBar(0);
      this.bindMobileScroll();
    }

    /**
     * Performance: goToSlide(0) used to force slides 1-2 of EVERY card on the page to download
     * as soon as this script ran (e.g. ~140 images on the homepage), competing with the LCP image.
     * Neighbouring slides are now preloaded once the card is within 300px of the viewport, so
     * the next slide is still ready before a visitor can reach the arrows or swipe.
     */
    observeNearViewport() {
      if (!('IntersectionObserver' in window)) {
        this.nearViewport = true;
        return;
      }
      if (this.nearViewportObserver) this.nearViewportObserver.disconnect();
      this.nearViewport = false;
      this.nearViewportObserver = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.nearViewportObserver.disconnect();
          this.nearViewport = true;
          this.lazyLoadNearby(this.currentIndex);
        },
        { rootMargin: '300px' }
      );
      this.nearViewportObserver.observe(this);
    }

    disconnectedCallback() {
      // Cards removed before reaching the viewport (e.g. a filter re-render) stop observing.
      if (this.nearViewportObserver) this.nearViewportObserver.disconnect();
    }

    bindEvents() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.prev();
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          this.next();
        });
      }

      // Stop parent slider-component from capturing drag/pointer events
      this.track.addEventListener('mousedown', (e) => e.stopPropagation());
      this.track.addEventListener('pointerdown', (e) => e.stopPropagation());

      // Keyboard navigation when focused
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          e.stopPropagation();
          this.prev();
        } else if (e.key === 'ArrowRight') {
          e.stopPropagation();
          this.next();
        }
      });
    }

    /**
     * Mobile scroll-snap detection
     * On mobile, pcs-track uses overflow-x: auto + scroll-snap
     * We listen to the scroll event to determine which slide is active
     */
    bindMobileScroll() {
      if (!this.track) return;

      this.track.addEventListener('scroll', () => {
        // Only process on mobile
        if (window.innerWidth >= this.mobileBreakpoint) return;

        // Debounce scroll events for performance
        if (this.scrollTimeout) {
          cancelAnimationFrame(this.scrollTimeout);
        }

        this.scrollTimeout = requestAnimationFrame(() => {
          this.onMobileScroll();
        });
      }, { passive: true });
    }

    onMobileScroll() {
      if (!this.track || this.totalSlides <= 1) return;

      const trackWidth = this.track.scrollWidth;
      const slideWidth = trackWidth / this.totalSlides;
      const scrollLeft = this.track.scrollLeft;

      // Calculate current slide index based on scroll position
      const newIndex = Math.round(scrollLeft / slideWidth);
      const clampedIndex = Math.max(0, Math.min(newIndex, this.totalSlides - 1));

      if (clampedIndex !== this.currentIndex) {
        this.currentIndex = clampedIndex;

        // Update aria attributes
        this.slides.forEach((slide, i) => {
          slide.classList.toggle('pcs-slide--active', i === clampedIndex);
          slide.setAttribute('aria-hidden', i !== clampedIndex);
        });

        // Update counter if exists
        if (this.counterCurrent) {
          this.counterCurrent.textContent = clampedIndex + 1;
        }

        this.lazyLoadNearby(clampedIndex);
      }

      // Update progress bar smoothly based on continuous scroll position
      // This gives a fluid progress feel even mid-swipe
      const scrollProgress = scrollLeft / (trackWidth - this.track.clientWidth);
      const clampedProgress = Math.max(0, Math.min(scrollProgress, 1));

      // Map scroll progress to slide-based progress
      // At scroll 0% → slide 1 of N → bar width = 1/N
      // At scroll 100% → slide N of N → bar width = N/N = 100%
      const barWidth = ((1 - clampedProgress) * (1 / this.totalSlides) + clampedProgress) * 100;

      this.updateProgressBarDirect(barWidth);
    }


    prev() {
      if (this.isTransitioning) return;
      const newIndex = this.currentIndex > 0 ? this.currentIndex - 1 : this.totalSlides - 1;
      this.goToSlide(newIndex);
    }

    next() {
      if (this.isTransitioning) return;
      const newIndex = this.currentIndex < this.totalSlides - 1 ? this.currentIndex + 1 : 0;
      this.goToSlide(newIndex);
    }

    goToSlide(index, animate = true) {
      if (index < 0 || index >= this.totalSlides) return;

      this.isTransitioning = animate;
      this.currentIndex = index;

      if (window.innerWidth >= this.mobileBreakpoint) {
        const offset = -(index * 100);
        this.track.style.transition = animate ? 'transform 0.3s ease' : 'none';
        this.track.style.transform = `translateX(${offset}%)`;
      }

      // Translate track
      const offset = -(index * 100);
      this.track.style.transition = animate ? 'transform 0.3s ease' : 'none';
      this.track.style.transform = `translateX(${offset}%)`;

      // Update active slide aria
      this.slides.forEach((slide, i) => {
        slide.classList.toggle('pcs-slide--active', i === index);
        slide.setAttribute('aria-hidden', i !== index);
      });

      // Update counter
      if (this.counterCurrent) {
        this.counterCurrent.textContent = index + 1;
      }

      this.updateProgressBar(index);

      // Lazy-load adjacent images (deferred until the card is near the viewport; see observeNearViewport)
      if (this.nearViewport) this.lazyLoadNearby(index);

      if (animate) {
        setTimeout(() => {
          this.isTransitioning = false;
        }, 300);
      }
    }

    /**
     * Update progress bar based on discrete slide index
     * Used by desktop (button navigation) and initial load
     */
    updateProgressBar(index) {
      if (!this.progressFill || this.totalSlides <= 1) return;
      const progress = ((index + 1) / this.totalSlides) * 100;
      this.progressFill.style.width = `${progress}%`;
    }

    /**
     * Update progress bar with a direct width value
     * Used by mobile scroll for smooth continuous updates
     */
    updateProgressBarDirect(widthPercent) {
      if (!this.progressFill || this.totalSlides <= 1) return;
      this.progressFill.style.width = `${widthPercent}%`;
    }

    lazyLoadNearby(index) {
      const indices = [index - 1, index, index + 1];
      indices.forEach((i) => {
        if (i >= 0 && i < this.totalSlides) {
          const img = this.slides[i].querySelector('img[loading="lazy"]');
          if (img && !img.dataset.pcsLoaded) {
            img.loading = 'eager';
            img.dataset.pcsLoaded = 'true';
          }
        }
      });
    }
  }

  customElements.define('product-card-slider', ProductCardSlider);
}

/**
 * Android-only helper class
 * Adds `is-android` to <html> and <body> so CSS can target Android devices reliably.
 */
(function () {
  try {
    const ua = navigator.userAgent || '';
    const platform = navigator.userAgentData && navigator.userAgentData.platform ? navigator.userAgentData.platform : '';
    const isAndroid = /Android/i.test(ua) || /Android/i.test(platform);

    if (!isAndroid) return;

    document.documentElement.classList.add('is-android');

    const addToBody = () => {
      if (document.body) document.body.classList.add('is-android');
    };

    if (document.body) addToBody();
    else document.addEventListener('DOMContentLoaded', addToBody, { once: true });
  } catch (e) {
    // no-op
  }
})();

function initFeaturedCollectionTabs(root) {
  const scope = root && root.querySelector ? root : document;
  const tabRoots = scope.querySelectorAll('.fc-collection-tabs[data-featured-collection-tabs]');

  tabRoots.forEach((group) => {
    if (group.__fcTabsBound) return;
    group.__fcTabsBound = true;

    const applyPanelSpacingClasses = (activePanel) => {
      if (!activePanel) return;
      const hasDesktopSlider = !!activePanel.querySelector('.slider--desktop');
      const hasTabletSlider = !!activePanel.querySelector('.slider--tablet');

      group.classList.toggle('is-fc-slider-desktop', hasDesktopSlider);
      group.classList.toggle('is-fc-slider-tablet', hasTabletSlider);
    };

    const setActive = (tabButton) => {
      if (!tabButton) return;

      const panelId = tabButton.getAttribute('data-fc-panel-id') || tabButton.getAttribute('aria-controls');
      if (!panelId) return;

      const tabButtons = group.querySelectorAll('button[role="tab"]');
      tabButtons.forEach((btn) => {
        const isActive = btn === tabButton;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-selected', String(isActive));
      });

      const panels = group.querySelectorAll('.fc-collection-tabs__panel[role="tabpanel"]');
      let activePanel = null;
      panels.forEach((panel) => {
        const isActive = panel.id === panelId;
        panel.hidden = !isActive;
        panel.classList.toggle('is-active', isActive);
        if (isActive) activePanel = panel;
      });

      applyPanelSpacingClasses(activePanel);
    };

    group.addEventListener('click', (e) => {
      const clickedTab = e.target.closest('button[role="tab"]');
      if (!clickedTab) return;
      e.preventDefault();
      e.stopPropagation();
      setActive(clickedTab);
    });

    group.addEventListener('keydown', (e) => {
      const focusedTab = e.target.closest('button[role="tab"]');
      if (!focusedTab) return;

      const tabButtons = Array.from(group.querySelectorAll('button[role="tab"]'));
      if (tabButtons.length === 0) return;

      const currentIndex = tabButtons.indexOf(focusedTab);
      if (currentIndex < 0) return;

      const goToIndex = (nextIndex) => {
        const nextTab = tabButtons[nextIndex];
        if (!nextTab) return;
        setActive(nextTab);
        try {
          nextTab.focus();
        } catch (_e) {
          // no-op
        }
      };

      if (e.key === 'ArrowRight') {
        e.preventDefault();
        const nextIndex = (currentIndex + 1) % tabButtons.length;
        goToIndex(nextIndex);
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        const nextIndex = (currentIndex - 1 + tabButtons.length) % tabButtons.length;
        goToIndex(nextIndex);
      } else if (e.key === 'Home') {
        e.preventDefault();
        goToIndex(0);
      } else if (e.key === 'End') {
        e.preventDefault();
        goToIndex(tabButtons.length - 1);
      }
    });

    // Ensure spacing classes are applied on first render (default tab),
    // not only after a user click.
    const initialActivePanel =
      group.querySelector('.fc-collection-tabs__panel[role="tabpanel"]:not([hidden])') ||
      group.querySelector('.fc-collection-tabs__panel[role="tabpanel"].is-active');
    applyPanelSpacingClasses(initialActivePanel);
  });
}

document.addEventListener('DOMContentLoaded', () => initFeaturedCollectionTabs(document));

document.addEventListener('shopify:section:load', (event) => {
  initFeaturedCollectionTabs(event && event.target ? event.target : document);
});

document.addEventListener('shopify:block:select', (event) => {
  const maybeTabButton = event && event.target && event.target.closest ? event.target.closest('.fc-collection-tabs__tab') : null;
  if (!maybeTabButton) return;

  const group = maybeTabButton.closest('.fc-collection-tabs');
  if (!group) return;

  initFeaturedCollectionTabs(group);

  const panelId = maybeTabButton.getAttribute('data-fc-panel-id') || maybeTabButton.getAttribute('aria-controls');
  if (!panelId) return;

  const tabButtons = group.querySelectorAll('button[role="tab"]');
  tabButtons.forEach((btn) => {
    const isActive = btn === maybeTabButton;
    btn.classList.toggle('is-active', isActive);
    btn.setAttribute('aria-selected', String(isActive));
  });

  const panels = group.querySelectorAll('.fc-collection-tabs__panel[role="tabpanel"]');
  let activePanel = null;
  panels.forEach((panel) => {
    const isActive = panel.id === panelId;
    panel.hidden = !isActive;
    panel.classList.toggle('is-active', isActive);
    if (isActive) activePanel = panel;
  });

  if (activePanel) {
    const hasDesktopSlider = !!activePanel.querySelector('.slider--desktop');
    const hasTabletSlider = !!activePanel.querySelector('.slider--tablet');
    group.classList.toggle('is-fc-slider-desktop', hasDesktopSlider);
    group.classList.toggle('is-fc-slider-tablet', hasTabletSlider);
  }

  try {
    maybeTabButton.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
  } catch (_e) {
    // no-op
  }
});

function initHeaderSearchRotatingSuggestions(root) {
  const scope = root && root.querySelector ? root : document;
  const wordElList = scope.querySelectorAll('.js-search-rotating-word[data-rotating-words]');

  wordElList.forEach((wordEl) => {
    let words = [];
    try {
      const raw = wordEl.getAttribute('data-rotating-words') || '[]';
      if (raw.trim().startsWith('[')) {
        const parsed = JSON.parse(raw);
        words = Array.isArray(parsed) ? parsed : [];
      } else {
        words = raw.split(',').map((w) => String(w || '').trim()).filter(Boolean);
      }
    } catch (_e) {
      try {
        const raw = wordEl.getAttribute('data-rotating-words') || '[]';
        const unescaped = raw
          .replace(/&quot;/g, '"')
          .replace(/&#34;/g, '"')
          .replace(/&amp;/g, '&');
        if (unescaped.trim().startsWith('[')) {
          const parsed = JSON.parse(unescaped);
          words = Array.isArray(parsed) ? parsed : [];
        } else {
          words = unescaped.split(',').map((w) => String(w || '').trim()).filter(Boolean);
        }
      } catch (_e2) {
        words = [];
      }
    }

    words = Array.isArray(words) ? words.map((w) => String(w || '').trim()).filter(Boolean) : [];
    if (words.length < 2) return;

    // Only lock once we have a valid list and we have an active timer.
    if (wordEl.__rotatingTimer) return;

    const baseText = (wordEl.getAttribute('data-base-text') || '').trim();
    const detailsModal = wordEl.closest('details-modal');
    // The search panel input keeps its fixed placeholder
    const modalInput = detailsModal ? detailsModal.querySelector('input.search__input') : null;
    const input = modalInput && !modalInput.hasAttribute('data-panel-placeholder') ? modalInput : null;
    const basePlaceholder = input ? (input.getAttribute('data-base-placeholder') || baseText).trim() : baseText;

    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    let idx = 0;
    const apply = () => {
      const next = words[idx % words.length];
      idx += 1;

      wordEl.textContent = next;

      if (input) {
        const isFocused = document.activeElement === input;
        const isEmptyValue = !input.value || input.value.trim() === '';
        if (!isFocused || isEmptyValue) {
          input.setAttribute('placeholder', basePlaceholder ? `${basePlaceholder} ${next}` : next);
        }
      }
    };

    // Align initial state to the first configured word.
    idx = 0;
    apply();

    const intervalMs = reduceMotion ? 4500 : 2200;
    const timer = window.setInterval(apply, intervalMs);
    wordEl.__rotatingTimer = timer;

    // Clean up if the element is removed (theme editor rerender).
    const observer = new MutationObserver(() => {
      if (!document.body.contains(wordEl)) {
        window.clearInterval(timer);
        wordEl.__rotatingTimer = null;
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
}

document.addEventListener('DOMContentLoaded', () => initHeaderSearchRotatingSuggestions(document));
document.addEventListener('shopify:section:load', (event) => initHeaderSearchRotatingSuggestions(event && event.target ? event.target : document));

function initHeaderSearchPlaceholderRotation(root) {
  const scope = root && root.querySelector ? root : document;
  const containers = scope.querySelectorAll('.fc-search-word-container.js-search-placeholder-rotator[data-search-words-csv]');

  containers.forEach((container) => {
    if (container.__fcPlaceholderRotatingTimer) return;

    const raw = container.getAttribute('data-search-words-csv') || '';
    const words = raw
      .split(',')
      .map((w) => String(w || '').trim())
      .filter(Boolean);

    if (words.length < 2) return;

    const baseText = (container.getAttribute('data-search-base-text') || '').trim();

    const detailsModal = container.closest('details-modal');
    // The search panel input keeps its fixed placeholder
    const modalInput = detailsModal ? detailsModal.querySelector('input.search__input') : null;
    const input = modalInput && !modalInput.hasAttribute('data-panel-placeholder') ? modalInput : null;
    const basePlaceholder = input ? (input.getAttribute('data-base-placeholder') || baseText).trim() : baseText;

    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const intervalMs = reduceMotion ? 4500 : 2200;
    let idx = 0;
    const apply = () => {
      const next = words[idx % words.length];
      idx += 1;

      // Sync input placeholder (don’t override user typing)
      if (input) {
        const isFocused = document.activeElement === input;
        const isEmptyValue = !input.value || input.value.trim() === '';
        if (!isFocused || isEmptyValue) {
          input.setAttribute('placeholder', basePlaceholder ? `${basePlaceholder} ${next}` : next);
        }
      }
    };

    // Set initial placeholder to the first word immediately.
    // Initialize visible word to first configured entry, then rotate.
    idx = 0;
    apply();

    const timer = window.setInterval(apply, intervalMs);
    container.__fcPlaceholderRotatingTimer = timer;

    const observer = new MutationObserver(() => {
      if (!document.body.contains(container)) {
        window.clearInterval(timer);
        container.__fcPlaceholderRotatingTimer = null;
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
}

document.addEventListener('DOMContentLoaded', () => initHeaderSearchPlaceholderRotation(document));
document.addEventListener('shopify:section:load', (event) =>
  initHeaderSearchPlaceholderRotation(event && event.target ? event.target : document)
);


window.addEventListener('load', function () {
  document.querySelectorAll('.js-hide-until-loaded').forEach(function(el) {
    el.style.opacity = '1';
    el.style.visibility = 'visible';
  });
});